import { combineReducers } from 'redux';

import { SNACKBAR } from './snackBarActions';

const message = (state = null, action) => {
  switch (action.type) {
    case SNACKBAR.SHOW_MESSAGE:
      return action.message;
    default:
      return state
  }
};

export default combineReducers({
  message,
});



// WEBPACK FOOTER //
// ./src/store/snackbar/snackBarReducer.js